import BaseApiRequest from "./BaseApiRequest";
import { PRODUCT_VAULT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetProductVaultRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  url = getCurrentUserParameters(
    `${PRODUCT_VAULT_URL}?timestamp=${new Date().getTime()}`
  );

  body = {};

  getMethod = () => this.method;

  getUrl = () => this.url;

  getBody = () => this.body;
}
